import { c as _c } from "react/compiler-runtime";
import premiereValue, { formatPremiereValueFromMovieInfo } from "src/components/filmpremiere/premiereValue";
import type OptionalPosterInfoType from "src/components/posterrow/OptionalPosterDisplayType";
import type { Movie, StreamingContent, WatchableContent } from "src/lib/movieinfo/movieinfotypes";
import { isMovie, isStreamingContent, isWatchableContent } from "src/lib/movieinfo/typeGuards";
import type { IFilmomtale } from "src/lib/types/Filmomtale";
import { isFilmomtale } from "src/lib/types/Filmomtale";

//#region [Props]
type OptionalPosterInfoProps = {
  optionalDisplay?: OptionalPosterInfoType;
  film: IFilmomtale | Movie | StreamingContent | WatchableContent;
  className?: string;
};
//#endregion

//#region [Component]
export default function OptionalPosterInfo(t0) {
  const $ = _c(7);
  const {
    optionalDisplay: t1,
    film,
    className
  } = t0;
  const optionalDisplay = t1 === undefined ? "year" : t1;
  if (!optionalDisplay) {
    return null;
  }
  let optInfo;
  if (optionalDisplay === "premiere") {
    if (isStreamingContent(film)) {} else {
      if (isWatchableContent(film)) {
        optInfo = film.premiereCinema;
      } else {
        if (isFilmomtale(film)) {
          optInfo = premiereValue(film.premiereOverride ?? film.premiere)?.premiere;
        } else {
          if (isMovie(film)) {
            if (film.isPremiereConfirmed) {
              let t2;
              if ($[0] !== film.premiere) {
                t2 = formatPremiereValueFromMovieInfo(film.premiere);
                $[0] = film.premiere;
                $[1] = t2;
              } else {
                t2 = $[1];
              }
              optInfo = t2;
            }
          }
        }
      }
    }
  } else {
    if (isStreamingContent(film)) {
      optInfo = film.year;
    } else {
      if (isWatchableContent(film)) {
        optInfo = film.productionYear;
      } else {
        if (isFilmomtale(film)) {
          let t2;
          if ($[2] !== film.year) {
            t2 = film.year?.toString();
            $[2] = film.year;
            $[3] = t2;
          } else {
            t2 = $[3];
          }
          optInfo = t2;
        } else {
          if (isMovie(film)) {
            optInfo = film.productionYear;
          }
        }
      }
    }
  }
  if (!optInfo) {
    return null;
  }
  let t2;
  if ($[4] !== className || $[5] !== optInfo) {
    t2 = <div className={className}>{optInfo}</div>;
    $[4] = className;
    $[5] = optInfo;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}
//#endregion